import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi, deleteApi} from '../utils/functions';
import {UserContext} from '../utils/usercontext';
import EventEmitter from '../utils/emmiter';
//import Genres from './components/genres/genres';
//import AudioBox from './components/audio/audiobox';
import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import './components/fontawesome/fontawesome';

//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';

//import './css/index.css';
//import './css/header.css';

export default class SupportEmail extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,
			
			emailTypes: [],
			service: 1000,
			services: [{id: 1000}],
		};
		this.getMail = this.getMail.bind(this);
		this.sendMail = this.sendMail.bind(this);
		this.setService = this.setService.bind(this);
  };

  async componentDidMount() {
		//document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( '/themes/default-dark.css' );
		EventEmitter.emit('/client', {data: 'no value'});

		//this.getWebsites();

		

		//this.setState({status: true});
		this.getMail();
		
		

	}

	componentWillUnmount() {
	}

	async getMail(service = 1000, emailtype = '') {
		let params = new URLSearchParams();
		params.append('service', service);
		params.append('emailtype', emailtype);
		const x = await postApi('/v3/support/email/template', params);
		console.log(x.data);
		
		this.setState({status: true, emailTypes: x.data.emailTypes?x.data.emailTypes:[], services: x.data.services?x.data.services:[]});
	}

	async sendMail(emailtype) {
		await this.getMail(this.state.service, emailtype);
	}

	async setService(service) {
		this.setState({emailTypes: [], service, services: [{id:1000}]},async ()=>{
			await this.getMail(service);
		});
	}



	render() {

		const emailTypes = this.state.emailTypes.map((e,i) => {
			return (
				<div key={i} className="col-6">
					<div className="card card-primary card-outline mb-4">
						<div className="card-header">
							<h3 className="card-title">Template: {e.type.charAt(0).toUpperCase()}{e.type.slice(1)}</h3>
							<span className="card-tools mx-2">
								<Button size="sm" onClick={()=>this.sendMail(e.type)}>Send Email</Button>
								{/*<Button size="sm" onClick={()=>this.editTemplate(e)}>Edit</Button>*/}
							</span>
						</div>
						<div className="card-body">
							{//this.state.template[e]?.content &&
								<>
									{this.state.edit === e ?
										<div className="" style={{height: '50vh'}}>
											{/*<Form.Control as="textarea" rows={5} name="body" value={this.state.editbody} onChange={this.handleChange} />
											<small>
												Reserved keywords:<br />
												{Object.keys(this.state.template[e].reserved).map((f,j) => {
													return (
														<React.Fragment key={j}>
															{this.state.template[e].reserved[f]}<br />
														</React.Fragment>
													)
												})}
											</small>
											<Button size="sm" onClick={(e)=>this.saveTemplate(e)}>Save</Button>&nbsp;<Button size="sm" onClick={()=>this.editTemplate(e)}>Cancel</Button>*/}
										</div>
									:
										<iframe id="EmailFrame" src={`data:text/html,${encodeURIComponent(e.content)}`} width="100%" frameBorder="0" scrolling="auto" style={{height: '75vh'}}></iframe>
									}
								</>
							}
						</div>
					</div>
				</div>
			)
		});

		const services = this.state.services.map((e,i) => {
			return (
				<Button key={i} onClick={()=>this.setService(e.id)}>{e.id}</Button>
			)
		});
		
		return (
			<>

				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Email</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								{/*<li className="breadcrumb-item"><a href="javascript:void(0);">Ui Elements</a></li>*/}
								<li className="breadcrumb-item active" aria-current="page">Email</li>
							</ol>
						</nav>
					</div>
				</div>

				{this.state.status &&
					<div className="main-content app-content">
						 
						<div className="container-fluid">

							<div className="my-4">
								<Row>
									
									<Col xs={12}>
										<div className="row row-cols-xxl-5 row-cols-xl-3 row-cols-md-2">
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium mb-1 text-muted">Total Sales</p>
																<h3 className="mb-0">$18,645</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-primary-transparent ms-auto">
																<i className="bi bi-cart-check fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-primary-transparent rounded-pill">+24% <i className="fe fe-arrow-down"></i></span>
															<a href="javascript:void(0);" className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</a>
														</div>
													</div>
												</div>
											</div>
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium mb-1 text-muted">Total Revenue</p>
																<h3 className="mb-0">$34,876</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-secondary-transparent ms-auto">
																<i className="bi bi-archive fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-success-transparent rounded-pill">+0.26% <i className="fe fe-arrow-down"></i></span>
															<a href="javascript:void(0);" className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</a>
														</div>
													</div>
												</div>
											</div>
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium text-muted mb-1">Total Products</p>
																<h3 className="mb-0">26,231</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-info-transparent ms-auto">
																<i className="bi bi-handbag fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-danger-transparent rounded-pill">+06% <i className="fe fe-arrow-down"></i></span>
															<a href="javascript:void(0);" className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</a>
														</div>
													</div>
												</div>
											</div>
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium mb-1 text-muted">Total Expenses</p>
																<h3 className="mb-0">$73,579</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-warning-transparent ms-auto">
																<i className="bi bi-currency-dollar fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-success-transparent rounded-pill">+10% <i className="fe fe-arrow-up"></i></span>
															<a href="javascript:void(0);" className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</a>
														</div>
													</div>
												</div>
											</div>
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium text-muted mb-1">Active Subscribers</p>
																<h3 className="mb-0">1,468</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-danger-transparent ms-auto">
																<i className="bi bi-bell fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-danger-transparent rounded-pill">+16% <i className="fe fe-arrow-down"></i></span>
															<a href="javascript:void(0);" className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</a>
														</div>
													</div>
												</div>
											</div>
										</div>
									</Col>

									<Col xs={12}>
										<div className="card">
											<div className="card-header">
												<h4 className="card-title">
													Service
												</h4>
											</div>
											<div className="card-body">
												<ButtonGroup size="sm">
													{services}
												</ButtonGroup>
											</div>
										</div>
										
									</Col>
									
									{emailTypes}

								</Row>
							</div>
						</div>
					</div>
				}
			</>
		);
	}
}
